<template>
  <!-- TaskLane - Begin -->
  <div class="card task-lane">
    <slot name="tower-header" v-bind:tower="tower">
      <h3 class="card-header">{{ tower.name }}</h3>
    </slot>

    <div class="card-body">
      <div v-for="card in cards" :key="card.id">
        <slot name="task-lane-item" v-bind:item="card">
          <!-- conteúdo fallback -->
          <div>{{ card }}</div>
        </slot>
      </div>
      <div v-show="hasNextPage" ref="load" class="loader">
        <strong>{{ $t("geral.loadingMoreData") }}</strong>
      </div>
      <div v-if="isRebuildingData">
        <strong>{{ $t("geral.loadingMoreData") }}</strong>
      </div>
    </div>

    <div ref="cardFooter" class="card-footer text-muted">
      <slot
        name="tower-footer"
        v-bind:amount="cardsAmount"
        v-bind:tower="tower"
      >
        <KanbanTaskLaneCounter :cardsAmount="cardsAmount" />
      </slot>
    </div>
  </div>
  <!-- <div>{{ towers }}</div> -->
</template>
        
<script>
import KanbanTaskLaneCounter from "./KanbanTaskLaneCounter.vue";

export default {
  name: "KanbanTaskLaneInfiniteScroll",
  props: {
    tower: Object,
  },
  data: function () {
    return {
      cards: [],
      cardsAmount: 0,
      currentPage: 0,
      perPage: 10,
      observer: null,
      observerCount: null,
      search: "",
      hasNextPage: true,
      isRebuildingData: false,
    };
  },
  components: {
    KanbanTaskLaneCounter,
  },
  destroyed() {
    this.observer.disconnect();
  },
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll);
    this.observer.observe(this.$refs.load);
  },
  methods: {
    async countItems() {
      let ctx = {
        tower: this.tower,
        searchQuery: this.searchQuery,
      };
      this.$emit("countItems", ctx, (itemsAmount) => {
        this.cardsAmount = itemsAmount;
      });
    },
    async getItems(loading, searchQuery) {
      let ctx = {
        tower: this.tower,
        items: [], // this.cards,
        perPage: this.perPage,
        currentPage: this.currentPage,
        hasNextPage: this.hasNextPage,
        loading,
        searchQuery,
      };
      this.$emit("getItems", ctx, (ctx) => {
        // if (this.tower.name == "AGUARDANDO ACEITE") {
        //   console.log("getItems == callback");
        //   console.log(ctx);
        // }
        // console.log("getItems == callback");
        // console.log(ctx);
        this.addCards(ctx.items);
        this.hasNextPage = ctx.hasNextPage;
        this.isRebuildingData = false;
        // console.log(this.hasNextPage);
      });
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        // console.log("infiniteScroll");
        // console.log(isIntersecting);
        // console.log(target);
        // console.log(target.parentElement);
        const ul = target.parentElement;
        const scrollTop = target.parentElement.scrollTop;
        this.currentPage++;
        await this.getItems(false, this.search);
        // this.limit += 10;
        await this.$nextTick();
        // console.log(scrollTop);
        // console.log(ul.scrollTop);
        ul.scrollTop = scrollTop;
      }
    },
    loadData() {
      let ctx = {
        tower: this.tower,
        items: this.cards,
      };
      let newItems = [];
      for (let card of ctx.tower.cards) {
        newItems.push({
          id: card.id,
          processId: card.processId,
          sortField: card.sortField,
          stageId: card.stageId,
          elapsedTime: card.elapsedTime,
          lastStatusLatitude: card.lastStatusLatitude,
          lastStatusLongitude: card.lastStatusLongitude,
          lastOccurrenceDate: card.lastOccurrenceDate,
          allowAttachment: card.allowAttachment,
          stageName: card.stageName,
          // text: card.text,
        });
        // ctx.items.push(card);
      }
      // this.$emit("loadData", ctx, newItems);
      if (newItems) {
        for (let newCard of newItems) {
          this.cards.push(newCard);
        }
      }
      //   this.$forceUpdate();
    },
    refreshData() {
      this.$emit("refreshData");
    },
    rebuildData() {
      this.isRebuildingData = true;
      this.hasNextPage = false;
      this.currentPage = 1;
      this.cardsAmount = 0;
      this.cards = [];
      this.countItems();
      // this.hasNextPage = true;
      this.getItems(false, this.searchQuery);
    },
    // addCard(newCard) {
    //   this.cards.push(newCard);
    //   this.cards = this.cards.sort(
    //     (a1, a2) => Date.parse(a1.sortField) - Date.parse(a2.sortField)
    //   );
    // },
    addCards(newCards) {
      let tempCards = [];
      for (let card of this.cards) {
        tempCards.push(card);
      }
      for (let card of newCards) {
        tempCards.push(card);
      }
      this.cards = tempCards.sort(
        (a1, a2) => Date.parse(a1.sortField) - Date.parse(a2.sortField)
      );
      this.$forceUpdate();
    },
    removeCard(cardRemove) {
      for (let i = this.cards.length - 1; i >= 0; i--) {
        let card = this.cards[i];
        if (card.id == cardRemove.id) {
          this.cards.splice(i, 1);
          this.$forceUpdate();
        }
      }
    },
  },
  provide() {
    return {
      countItems: () => {
        this.countItems();
      },
    };
  },
};
</script>
        
<style scoped>
.card-body {
  overflow: auto;
  /* height: 100%; */
  /* height: calc(100vh - 270px); */
}

.task-lane {
  height: 100%;
  /* height: calc(100vh - 140px); */
  /* height: calc(100vh - 170px); */
}
</style>